import "./Header.css"

function Header(){
    return <header className="header">
        <img src='/img/HeaderHeader.png' alt="baner"></img>
    </header>
};

export default Header;